import { DropdownArrow } from '@hendrx/icons/DropdownArrow';
import { SelectProps } from '@mantine/core';
import { Editor } from '@tiptap/react';
import { useTranslation } from 'react-i18next';

import { Select } from 'shared/components/selects/Select';
import { SelectOption } from 'shared/components/selects/SelectOption';
import { rem } from 'shared/utils/rem';
import { useGlobalTheme } from 'shared/utils/useGlobalTheme';

import { Level } from '../../../../utils/tiptap/extensions/heading';
import { TypographyIdType } from '../../../../utils/typographyStyles';
import { useToolbarSelectStyles } from '../useToolbarSelectStyles';

type TextLevel = { value: string; label: string };
export type TextLevelSelectProps = {
  editor: Editor | null;
  textLevels: TextLevel[];
};

export function TextLevelSelect(props: TextLevelSelectProps) {
  const { editor, textLevels } = props;
  const theme = useGlobalTheme();

  const { classes, style } = useToolbarSelectStyles({ maxWidth: 112 });
  const { t } = useTranslation('widgets.headingSelect');

  const isActiveParagraph = editor?.isActive('paragraph');
  const isActiveHeader = editor?.isActive('heading');

  let activeHeading = textLevels[0].value;
  if (isActiveParagraph) {
    activeHeading = 'p';
  } else if (isActiveHeader) {
    activeHeading = editor?.getAttributes('heading').level?.toString();
  }
  const handleHeadingChange = (level: string) => {
    const newLevel = level === '0' ? activeHeading : level;

    if (newLevel === 'p') {
      editor?.chain().focus().setParagraph().run();
    } else {
      const currentLevel: TextLevel = textLevels.find(item => item.value === newLevel) as TextLevel;
      editor
        ?.chain()
        .focus()
        .toggleHeading({ level: newLevel as Level })
        .setFontSize(rem(`${theme.other.fonts[currentLevel?.label as TypographyIdType].fontSize}`))
        .run();
    }
  };

  return (
    <Select
      title={t('headingTitle') ?? ''}
      style={style}
      styles={{ dropdown: style }}
      classNames={{
        root: classes.selectRoot,
        input: classes.selectInput,
        section: classes.selectIcon,
        dropdown: classes.selectDropdown
      }}
      data={textLevels.map(({ label, value }) => ({ value, label: t(label) }))}
      value={activeHeading}
      onChange={handleHeadingChange as SelectProps['onChange']}
      variant="unstyled"
      leftSection={<DropdownArrow />}
      leftSectionWidth={24}
      leftSectionPointerEvents="auto"
      rightSection={<></>}
      rightSectionWidth={'0px'}
      renderOption={({ option, checked }) => <SelectOption checked={checked}>{option.label}</SelectOption>}
    />
  );
}
